import { render } from "./IconYoutube.vue?vue&type=template&id=2f2fa5ce"
import script from "./IconYoutube.vue?vue&type=script&lang=js"
export * from "./IconYoutube.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__